import { PropsWithChildren } from 'react';
import { BackgroundWrapper } from './styles';

const ContentWrapper = ({ children }: PropsWithChildren) => {
  return <BackgroundWrapper>{children}</BackgroundWrapper>;
};

export default ContentWrapper;
